import axios from '@/core/http'
import { saveAs } from 'file-saver'
import { Repository } from './repository'

class StreamRepository extends Repository {
  URL = 'recordings/streams/'
}

const fetchStreamRecorderTypes = () => {
  return axios.get('recordings/streams/recorders/').then(res => res.data)
}
const downloadStreamAudioSample = (streamId: string) => {
  return axios
    .get(`recordings/streams/${streamId}/capture-audio-test/`, { responseType: 'blob' })
    .then(response => {
      saveAs(new Blob([response.data]), 'sample.wav')
    })
}
const downloadStreamVideoSample = (streamId: string) => {
  return axios
    .get(`recordings/streams/${streamId}/capture-video-test/`, { responseType: 'blob' })
    .then(response => {
      saveAs(new Blob([response.data]), 'sample.mp4')
    })
}

export {
  StreamRepository,
  fetchStreamRecorderTypes,
  downloadStreamAudioSample,
  downloadStreamVideoSample,
}
